import { Component } from '@angular/core';
import { AlertController, Events, IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { ActionPlanProvider } from '../../providers/action-plan/action-plan';

/**
 * Generated class for the SelectActionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-select-action',
  templateUrl: 'select-action.html',
})
export class SelectActionPage {

  auditId:string;
  audit: any;
  actionsArray: any[] = []
   loader:any;
  currentItem:any;
  actionData: any;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private alertCtrl: AlertController, public events:Events, private actionProvider: ActionPlanProvider,public loadingCtrl: LoadingController, ) {

      if(this.navParams.data.auditId){
        this.auditId = this.navParams.data.auditId;
        // console.log(this.auditId)
      }
  }

  statusList: any[] = [];


  ionViewWillEnter(){
    this.showLoading();
    this.actionReportData();

}

showLoading(){

      this.loader =  this.loadingCtrl.create({
            content: 'Please wait, Building Action Plan for you...',
            duration: 100000
      });

      this.loader.present();
  }

  hideLoading(){
      if(this.loader){
           this.loader.dismiss();
      }
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad SelectActionPage');
  }

  onDragStart(item:any) {
    this.currentItem = item
  }

  filterActions(status: string) {
    if(this.actionsArray.length){
      return this.actionsArray.filter(m=>m.status == status && m.actionHeadline != null)
    }
  }


  async onDrop(e: any, status: boolean) {
    e.preventDefault();
  
    const leftBoxItemCount = this.actionsArray.filter(m => m.status === true).length;
    
    if (status === true) {
       

        const recordIndex = this.actionsArray.findIndex(m => m.question === this.currentItem.question);
        if (recordIndex !== -1) {
          // Update the status
          this.actionsArray[recordIndex].status = status;
  
          // Remove the item from its current position
          const [movedItem] = this.actionsArray.splice(recordIndex, 1);
  
          // Insert the item at the top of the list
          this.actionsArray.unshift(movedItem);
        }
      if (leftBoxItemCount > 3) {

           let lastTrueIndex = -1;
           for (let k = this.actionsArray.length - 1; k >= 0; k--) {
                if(this.actionsArray[k]['status']){
                  lastTrueIndex = k;
                  break;
                }
           }
         
          console.log("lastTrueIndex",lastTrueIndex);
          this.actionsArray[lastTrueIndex].status = false;
          const [movedItemLast] = this.actionsArray.splice(lastTrueIndex, 1);
          this.actionsArray.push(movedItemLast);
      } 
    } else {
      const recordIndex = this.actionsArray.findIndex(m => m.question === this.currentItem.question);
      if (recordIndex !== -1) {
        // Update the status
        this.actionsArray[recordIndex].status = status;
  
        // Remove the item from its current position
        const [movedItem] = this.actionsArray.splice(recordIndex, 1);
  
        // Insert the item at the top of the list
        this.actionsArray.push(movedItem);
      }
    }
  
    this.currentItem = null;
    console.log('actionsArray1', this.actionsArray);
  }

  async showAlert() {
    const alert = await this.alertCtrl.create({
      message: 'You can only drag up to 4 items to the left box.',
      cssClass: 'action-alert',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            // console.log('cancel');
            // Add your action for continuing the task here
          }
        },
        {
          text: 'Ok',
          handler: () => {
            // console.log('Ok');
            // Add your action for completing the task here
          }
        }
      ]
    });

    await alert.present();
  }
  
  onDragOver(e: any) {
    // console.log('onDragOver');
    e.preventDefault();
    // console.log('actionsArray2', this.actionsArray);
  }

  async submitAction() {

    // console.log(this.actionsArray)
    // const alert = await this.alertCtrl.create({
    //   message: 'Submit Successfully!',
    //   cssClass: 'action-alert',
    //   buttons: [
    //     {
    //       text: 'Ok',
    //       handler: () => {
            console.log('Ok');
    //         // Add your action for completing the task here
    //       }
    //     }
    //   ]
    // });

    // await alert.present();
    //  this.actionsArray.forEach((item, index) => {

       let updatedActionDetailsData = [];

       for (let k = 0; k < this.actionsArray.length; k++) {
        let matchItem = false;
        console.log('itemmmmmmmmmmmmmmm', this.actionsArray[k])
        console.log(' this.actionData[0].actionDetails[index]', this.actionData[0].actionDetails[k]);
  
        for (let i = 0; i < this.actionData[0].actionDetails.length; i++) {
            console.log('this.actionData[0].actionDetails', this.actionData[0].actionDetails[i]);
           
               
                if (this.actionData[0].actionDetails[i].content.auditReportContent[0].actionHeadline == this.actionsArray[k].actionHeadline) {

                    this.actionData[0].actionDetails[i].content.auditReportContent[0].status = this.actionsArray[k].status;
                     updatedActionDetailsData.push(this.actionData[0].actionDetails[i]);
                    
                     break;
                }
            
         
        }
    }

      console.log("updatedActionDetailsData",updatedActionDetailsData);

       this.actionData[0].actionDetails = updatedActionDetailsData;
      
      console.log("this.actionArray",this.actionsArray);

      console.log('this.actionData', this.actionData);

      await this.actionProvider.updateActionPlanCollection(this.auditId,this.actionData);
      
     this.navCtrl.pop();
      this.events.publish('audit:getAudit',this.auditId);
  }



  async actionReportData(){

    const result = await this.actionProvider.actionReportData(this.auditId);
    

    // for(let i = 0; i < result.length; i++){
    //   if(i < 3)  result[i].status = true;
    //   else  result[i].status = false;     
    // }
   
    await this.createActionPlanCollectionAndFetchData(result);

  }

  async createActionPlanCollectionAndFetchData(data){
  console.log("Inside createActionPlanCollectionAndFetchData",this.auditId);
    this.actionData = await this.actionProvider.checkAndCreateActionPlanCollection(this.auditId, data);
    // console.log('result****************')
    console.log(this.actionData)

    this.actionData[0].actionDetails.forEach((qa, index) => {
        // questionList.push({ text: qa.question, style: 'questionStyle' });
      
        if (qa.content && qa.content.auditReportContent) {
          qa.content.auditReportContent.forEach((action) => {
           
                this.actionsArray.push({actionHeadline: action.actionHeadline,
                  actionDetails: action.actionDetails,
                  status: action.status,
                  question: qa.question,
                  idCount: action.idCount
                });
                      
          });
        }
      });

      console.log('this.actionsArray', this.actionsArray)

      this.hideLoading();

      // console.log('actionsArray', this.actionsArray)
  }

  onScroll(event:any) {
    // console.log('event', event)
  }

  

}



// WEBPACK FOOTER //
// ./src/pages/select-action/select-action.ts